module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/generic-loading-box/generic-loading-box.component.html
// module id = ./src/app/modules/common-module/components/generic-loading-box/generic-loading-box.component.html
// module chunks = 9